export const baseUrl = {
  development: "http://localhost:3000",
  production: "https://stagingwtgapi-2f0z.onrender.com/",
};
